import React, { useEffect, useState } from "react";
import {
  Button,
  Grid,
  makeStyles,
  TextField,
  Typography,
} from "@material-ui/core";
import MomentUtils from "@date-io/moment";
import InputMask from "react-input-mask";
import moment from "moment";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import SearchIcon from "@material-ui/icons/Search";
import styles from "../../../styles/global-styles";
import CategorySelect from "../../shared/selects/CategorySelect";
import SiteSelect from "../../shared/selects/SiteSelect";
import StatusDistributionSelect from "../../shared/selects/StatusDistributionSelect";
import { filterProductsInDistribution } from "./utils.distributions";
import { DistributionService } from "../../../services/distribution.service";
import LoteDistributionSelect from "../../shared/selects/LoteDistributionSelect";
import { NotificationService } from "../../../services/notification.service";
import { AuthService } from "../../../services/auth.service";

const useStyles = makeStyles((theme) => ({
  title: styles.title,
  table: {
    minWidth: 700,
  },
  subtitle: styles.subtitle,
  textField: {
    "& .MuiOutlinedInput-root": {
      width: "230px",
      maxWidth: 250,
    },
  },
}));

const HeaderDistribution = ({
  title,
  distributionsfiltered,
  isGlobalDistribution,
}) => {
  const classes = useStyles();
  const { id, siteId } = AuthService.currentUserValue;
  let noDataFound = {
    noData: "No se encontraron distribuciones con los filtros seleccionados",
  };

  const [queryParams, setqueryParams] = useState({});
  const [notificationObject, setNotificationObject] = useState([]);
  const [startDate, setStartDate] = React.useState(
    moment().subtract(1, "days").startOf("day").format()
  );
  const [endDate, setEndDate] = React.useState(moment().endOf("day").format());

  useEffect(() => {
    if (!isGlobalDistribution) {
      (async function () {
        loadNotifications();
      })();
    }
  }, []);

  useEffect(() => {
    if (queryParams.numberValue)
      setqueryParams({ ...queryParams, numberValue: "" });
  }, [queryParams.productTypeId]);

  useEffect(() => {
    if (!isGlobalDistribution) {
      loadNotifications();
    }
  }, [startDate || endDate]);

  const loadNotifications = async () => {
    try {
      const { data } = await NotificationService.getAllNotificationsWithParams({
        userId: id,
        siteId,
        startDate,
        endDate,
      });
      let notifObject = {};
      console.log("data getAllNotificationsWithParams", data);
      const idNotificationsArray = data.map((item) => item.id);
      data.forEach((item) => {
        notifObject[item.id] = item.distributionsId;
      });
      console.log("notifObject", notifObject);
      setNotificationObject(notifObject);
      const distributionsIdArray = data.map((item) => item.distributionsId);
      console.log("distributionsIdArray", distributionsIdArray);
      // setdistributionsId([].concat(...distributionsIdArray));
    } catch (error) {
      console.log("error notifications", error);
      // addAlert({ showAlert: true });
      // detailAlert({ severity: "error", message: error.msgs });
    }
  };

  const handleStartChange = (date) =>
    setStartDate(moment(date).startOf("day").format());

  const handleEndChange = (date) =>
    setEndDate(moment(date).endOf("day").format());

  const handleOptionSelected = (key, value) =>
    setqueryParams({ ...queryParams, [key]: value === "none" ? "" : value });

  const searchDistributionByFilters = async () => {
    let body = {};
    // build body for DistributionService
    if (moment(endDate).isAfter(moment(startDate))) {
      if (!isGlobalDistribution) {
        body = {
          userId: id,
          siteDestinationId: queryParams.siteId,
          statusDistributionId: queryParams.statusDistributionId,
          productTypeId: queryParams.productTypeId,
          startDate,
          endDate,
        };
      } else {
        body = {
          siteDestinationId: queryParams.siteId,
          statusDistributionId: queryParams.statusDistributionId,
          productTypeId: queryParams.productTypeId,
          startDate,
          endDate,
        };
      }
      console.log("query params", body);
      try {
        const { data } =
          await DistributionService.getAllDistributionsWithParams(body);
        if (data.length) {
          const filterResults = filterProductsInDistribution(data);
          console.log("filterResult length", filterResults.length);
          if (isGlobalDistribution) {
            distributionsfiltered(filterResults, true, queryParams.numberValue);
          } else {
            // Remove cancelated distributions (just admin role can see this status 4)
            const distribsWithoutCancellation = filterResults.filter(
              (item) => item.statusDistributionId !== 4
            );
            /** Add idNotification (lote) to each row distribution */
            distribsWithoutCancellation.forEach((item, index) => {
              Object.entries(notificationObject).forEach(([key, value]) => {
                value.forEach((id) => {
                  if (parseInt(id) === item.id) {
                    distribsWithoutCancellation[index] = {
                      ...distribsWithoutCancellation[index],
                      lote: key,
                    };
                  }
                });
              });
            });

            /** filter by lote selected */
            if (queryParams.lote) {
              // console.log("lote selected", queryParams.lote);
              const filterProductsByLote = distribsWithoutCancellation.filter(
                (item) => item.lote === queryParams.lote
              );
              if (filterProductsByLote.length)
                distributionsfiltered(filterProductsByLote, true);
              else {
                throw noDataFound;
              }
            } else {
              /** filter without lote selected */
              distributionsfiltered(distribsWithoutCancellation, true);
            }
          }
        } else {
          throw noDataFound;
        }
      } catch (error) {
        console.log("error", error);
        distributionsfiltered(error, false);
      }
    } else {
      noDataFound = {
        dateError: "La fecha de inicio es MAYOR a la fecha de fin",
      };
      distributionsfiltered(noDataFound, false);
    }
  };

  const handleNumberInput = ({ target: { value } }) => {
    setqueryParams({ ...queryParams, numberValue: value });
  };

  const showPlaceHolder = () => {
    let text = "";
    if (queryParams.productTypeId) {
      text =
        queryParams.productTypeId === 1
          ? "IMEI"
          : queryParams.productTypeId === 2
          ? "Código de barras"
          : "ICCID";
    }
    return text;
  };

  const InputMaskNumber = () => {
    if (queryParams.productTypeId === 1) {
      // length 15
      return "999999999999999";
    } else if (queryParams.productTypeId === 2) {
      // length 13
      return "9999999999999";
    } else return "9999999999999999999"; // length 19
  };

  const InputTextSearch = () => {
    if (
      queryParams.productTypeId === 1 ||
      queryParams.productTypeId === 2 ||
      queryParams.productTypeId === 3
    ) {
      return (
        <Grid item style={{ marginTop: 30 }}>
          {/**CONSIDERAR EL TAMAÑO para  ICCID; IMEI, BARCODE */}
          <InputMask
            mask={InputMaskNumber()}
            maskChar=""
            value={queryParams.numberValue || ""}
            onChange={(e) => handleNumberInput(e)}
          >
            {() => (
              <TextField
                className={classes.textField}
                name="checkProducts"
                placeholder={showPlaceHolder()}
                variant="outlined"
              />
            )}
          </InputMask>
        </Grid>
      );
    }
  };
  return (
    <>
      <Typography variant="h4" component="h4" className={classes.title}>
        {title}
      </Typography>
      <Grid
        container
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        {
          <MuiPickersUtilsProvider utils={MomentUtils}>
            <Grid item>
              <DatePicker
                disableToolbar
                variant="inline"
                format="DD/MM/yyyy"
                margin="normal"
                autoOk
                disableFuture
                label="Fecha de inicio"
                placeholder="20/02/2021"
                value={startDate}
                onChange={handleStartChange}
              />
            </Grid>
            <Grid item>
              <DatePicker
                disableToolbar
                variant="inline"
                format="DD/MM/yyyy"
                margin="normal"
                autoOk
                placeholder="21/02/2021"
                disableFuture
                label="Fecha de fin"
                value={endDate}
                onChange={handleEndChange}
              />
            </Grid>
          </MuiPickersUtilsProvider>
        }
        {!isGlobalDistribution && (
          <Grid item>
            <LoteDistributionSelect
              loteArray={Object.keys(notificationObject)}
              lote={handleOptionSelected}
            />
          </Grid>
        )}
        <Grid item>
          <CategorySelect
            category={handleOptionSelected}
            showNone
            showAll={false}
          />
        </Grid>
        <Grid item>
          <StatusDistributionSelect
            status={handleOptionSelected}
            showAllStatus={isGlobalDistribution}
          />
        </Grid>
        {isGlobalDistribution && (
          <>
            <Grid item>
              <SiteSelect
                title="Sucursal destino"
                site={handleOptionSelected}
                removeStore
                showNone
              />
            </Grid>

            {InputTextSearch()}
          </>
        )}
        <Grid item>
          <Button
            disabled={!Object.keys(queryParams).length}
            className={classes.rightButton}
            variant="contained"
            color="primary"
            onClick={searchDistributionByFilters}
            endIcon={<SearchIcon color="secondary" />}
          >
            Buscar
          </Button>
        </Grid>
      </Grid>
    </>
  );
};

export default HeaderDistribution;
